
<template>
  <div>
    <vue-element-loading
      :active="appLoading"
      :is-full-screen="true"
      background-color="#FFFFFF"
      color="#FDAC53"
      spinner="bar-fade-scale"
    />
    <ServerError v-if="ServerError" />
    <v-snackbar v-model="showSnackBar" color="#FDCE48" right timeout="3000">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">
          <span style="color: #fff">
            {{ msg }}
          </span>
        </v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showSnackBar = false">
            <v-icon style="color: #000">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap>
      <v-flex
        xs12
        pt-1
        style="font-family: poppinssemibold; font-size: 22px"
        class="clr"
      >
        <h3>Add Product</h3>
      </v-flex>
    </v-layout>

    <v-layout wrap>
      <v-flex xs12 md6 lg3>
        <v-text-field label="Product Name" v-model="name"> </v-text-field>
      </v-flex>
      <v-flex xs12 md6 lg3 pl-2>
        <v-select
          label="Category"
          :items="CategoryList"
          v-model="category"
          item-text="name"
          item-value="_id"
        >
        </v-select>
      </v-flex>
      <v-flex xs12 md6 lg3 pl-2>
        <v-select
          :items="SubCategoryList"
          v-model="Subcategory"
          item-text="name"
          item-value="_id"
          label="Sub Category"
          @input="getCurrentHSN(Subcategory)"
        >
        </v-select>
      </v-flex>
      <v-flex xs12 md6 lg3>
        <v-select
          :items="foodTypes"
          v-model="foodType"
          type="number"
          prepend-icon="mdi-egg"
          label="Type"
        >
        </v-select>
      </v-flex>
      <v-flex xs12 lg12 pt-3>
        <v-form ref="form">
          <v-textarea
            height="80px"
            :rules="[rules.length]"
            v-model="description"
            label="Description"
          >
          </v-textarea>
        </v-form>
      </v-flex>
      <v-flex xs12 lg3>
        <v-autocomplete
          :items="HSNList"
          item-text="hsnCode"
          item-value="_id"
          type="number"
          v-model="HSNCode"
          label="HSN Code"
          @input="ChangeHSN(HSNCode)"
        >
        </v-autocomplete>
      </v-flex>

      <v-flex xs12 lg3 pl-3>
        <v-text-field
          disabled
          type="number"
          label="GST Slab1 percentage"
          prepend-inner-icon="mdi-percent"
          v-model="Slab1percentage"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 lg3 pl-3>
        <v-text-field
          disabled
          type="number"
          v-model="Slab2percentage"
          prepend-inner-icon="mdi-percent"
          label="GST Slab2 percentage"
        >
        </v-text-field>
      </v-flex>
      <v-flex xs12 lg3 pl-3>
        <v-text-field
          disabled
          type="number"
          v-model="Slab2price"
          prepend-inner-icon="mdi-currency-inr"
          label="GST Slab2 price"
        >
        </v-text-field>
      </v-flex>

      <v-flex xs12 pl-2 v-if="HSNName != null">
        <v-card style="border-radius: 20px" color=" #ffd633">
          <v-layout wrap pa-1>
            <v-flex xs12>
              {{ HSNName }}
            </v-flex>
          </v-layout>
        </v-card>
      </v-flex>

      <!-- <v-flex xs12 text-left pt-3>
        <span>Product Detail</span> <br />
        <vue-editor class="pt-1" v-model="productDetail"></vue-editor>
      </v-flex> -->
      <v-flex xs12 v-for="(item, i) in variants" :key="i">
        <v-layout wrap>
          <v-flex xs12 lg3 px-1>
            <v-text-field label="Variant Name" v-model="item.varientName">
            </v-text-field>
          </v-flex>

          <v-flex xs12 lg3 px-1>
            <v-text-field
              type="number"
              label="Product Weight (Kg)"
              v-model="item.productWeight"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 lg3 px-1>
            <v-select
              label="Quantity Type"
              v-model="item.quantityType"
              :items="quantityTypes"
            >
            </v-select>
          </v-flex>
          <v-flex xs12 lg3 px-1>
            <v-text-field
              type="number"
              :label="'Quantity(' + item.quantityType + ')'"
              v-model="item.quantity"
            >
            </v-text-field>
          </v-flex>

          <v-flex xs12 lg3 px-2>
            <v-text-field
              type="number"
              prepend-inner-icon="mdi-numeric"
              v-model="item.minimumOrderQuantity"
              label="Minimum Order Quantity"
            >
            </v-text-field>
          </v-flex>

          <v-flex xs12 lg3 px-2>
            <v-text-field
              type="number"
              prepend-inner-icon="mdi-numeric"
              v-model="item.maxOrderQuantity"
              label="Maximum Order Quantity"
            >
            </v-text-field>
          </v-flex>
          <v-flex xs12 text-left pt-3 pb-1>
            <span>Product Detail</span> <br />
            <vue-editor class="pt-1" v-model="item.productDetails">
            </vue-editor>
          </v-flex>

          <v-flex xs12 md12 lg4 pb-4>
            <ImageComp
              @stepper="winStepper"
              :height="'10'"
              :width="'10'"
              :heading="'Upload Main Image'"
              :componentType="'offerImage'"
              :index="i"
            />
          </v-flex>
          <v-flex xs12 md12 lg4 pb-4 px-1>
            <ImageComp
              @stepper="winStepper"
              typr
              :height="'10'"
              :width="'10'"
              :heading="'Upload Product Image'"
              :componentType="'restaurantImage'"
              :index="i"
            />
          </v-flex>
          <v-flex xs12 md12 lg4 pb-4>
            <ImageComp
              @stepper="winStepper"
              typr
              :height="1"
              :width="1"
              :heading="'Upload Packing Image'"
              :componentType="'packingImage'"
              :index="i"
            />
          </v-flex>
          <v-flex xs12 px-1 align-self-baseline text-right pt-1>
            <v-btn
              v-if="i > 0"
              color="error"
              rounded
              @click="
                variants.splice(i, 1),
                  productImages.splice(i, 1),
                  packingImages.splice(i, 1),
                  packedImages.splice(i, 1)
              "
            >
              <v-icon>mdi-minus</v-icon></v-btn
            >
          </v-flex>

          <v-flex xs12 pt-4 style="border-bottom: 3px solid black"> </v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs12 lg12 pt-3 text-right>
        <v-btn
          dark
          dense
          color="primary"
          style="text-decoration: none"
          rounded
          @click="addVariant"
        >
          add variant <v-icon x-small>mdi-plus</v-icon></v-btn
        >
      </v-flex>
      <v-flex xs12 lg12 pt-3>
        <v-btn
          dark
          dense
          block
          color="black"
          style="text-decoration: none"
          @click="UploadData()"
        >
          Save
        </v-btn>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import axios from "axios";
import ImageComp from "@/components/Common/GroceryImage";
// import { eventBus } from "../../main";
export default {
  components: {
    ImageComp,
  },
  data() {
    return {
      Slab1percentage: null,
      Slab2percentage: null,
      Slab2price: null,

      HSNCode: null,
      HSNName: null,
      stockId: null,
      menu: false,
      menu1: false,

      productDetail: null,
      Brands: [],
      ServerError: false,
      showSnackBar: false,
      msg: "",
      productImages: [],
      packingImages: [],
      packedImages: [],
      variants: [
        {
          maxOrderQuantity: 10,
          minimumOrderQuantity: 1,
          menu: false,
          menu1: false,
          shelfLife: null,
          manufacturingDate: null,
          expDate: null,
          brand: null,
          commissionType: null,
          commissionPercentage: 0,
          commission: 0,
          varientName: null,
          price: null,
          productWeight: null,
          quantityType: "Kilogram",
          quantity: null,
          discount: 0,
          offerPrice: null,
          index: null,
          productDetails: null,
        },
      ],
      singleVariant: {
        maxOrderQuantity: 10,
        minimumOrderQuantity: 1,
        menu: false,
        menu1: false,
        shelfLife: null,
        manufacturingDate: null,
        expDate: null,
        brand: null,
        commissionType: null,
        commissionPercentage: 0,
        commission: 0,
        varientName: null,
        price: null,
        productWeight: null,
        quantityType: "Kilogram",
        quantity: null,
        discount: 0,
        offerPrice: null,
        index: null,
        productDetails: null,
      },
      description: null,
      name: null,
      CategoryList: [],
      category: null,
      SubCategoryList: [],
      Subcategory: null,
      foodTypes: ["Vegetarian", "Non-vegetarian", "Eggetarian"],
      quantityTypes: ["Kilogram", "Gram", "Litre", "Milli litre", "Count"],
      foodType: null,
      //size
      appLoading: false,
      rules: {
        length: (value) => value.length >= 150 || "min 150 characters",

        required: (value) => !!value || "Required.",
        counter: (value) => value.length <= 20 || "Max 20 characters",
        discount: (value) =>
          (value < 100 && value >= 0) || "Discount must be between 0-100",
        offerPrice: (value) => value >= 0 || "Offer price should be valid ",
      },
    };
  },

  computed: {
    HSNList() {
      return this.$store.state.HSNList;
    },
  },
  watch: {
    category() {
      this.getSubCategory(this.category);
    },
  },
  mounted() {
    this.getProductTypes();
    this.getCategories();
    this.getAllergens();
    this.getCategory();
    this.getBrands();
    // console.log(this.HSNList)
    // this.getHSN();
  },
  methods: {
    getCurrentHSN(value) {
      this.HSNCode = null;
      var index = this.SubCategoryList.findIndex(
        (myval) => myval._id === value
      );
      this.HSNCode = this.SubCategoryList[index].hsnCodeId._id;
      this.HSNName = this.SubCategoryList[index].hsnCodeId.name;
      this.Slab1percentage =
        this.SubCategoryList[index].hsnCodeId.gstSlab1Percentage;
      this.Slab2percentage =
        this.SubCategoryList[index].hsnCodeId.gstSlab2Percentage;
      this.Slab2price =
        this.SubCategoryList[index].hsnCodeId.gstSlab2MinimumPrice;
    },
    ChangeHSN(HSN) {
      let myname = null;
      myname = this.HSNList.find(changeName);
      function changeName(value) {
        if (value._id === HSN) {
          return value.name;
        }
      }

      //  myname = this.HSNList.find((item) => { console.log("itemzzzz========",item) ;  item._id == HSN })

      this.HSNName = myname.name;
      this.Slab1percentage = myname.gstSlab1Percentage;
      this.Slab2percentage = myname.gstSlab2Percentage;
      this.Slab2price = myname.gstSlab2MinimumPrice;
    },
    getBrands() {
      this.appLoading = true;
      axios({
        url: "/grocery/brand/get/list",
        method: "get",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.Brands = response.data.data;
          // this.pages = response.data.totalPages;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    checkOfferPricevariant(index) {
      if (typeof this.variants[index].offerPrice == "string") {
        this.variants[index].offerPrice = parseInt(
          this.variants[index].offerPrice
        );
      }
      if (this.variants[index].offerPrice <= this.variants[index].price) {
        this.variants[index].discount = (
          100 -
          (this.variants[index].offerPrice / this.variants[index].price) * 100
        ).toFixed(2);
      } else {
        this.msg = "Please Provide valid offer price";
        this.snackbar = true;
        this.offerPrice = this.price;
        this.discount = 0;
      }

      if (this.variants[index].offerPrice >= this.variants[index].commission) {
        this.variants[index].commissionPercentage = (
          ((this.variants[index].offerPrice -
            (this.variants[index].offerPrice -
              this.variants[index].commission)) /
            this.variants[index].offerPrice) *
          100
        ).toFixed(2);
      } else {
        this.msg = "Please Provide valid commission price";
        this.snackbar = true;
        this.variants[index].offerPrice = this.variants[index].price;
        this.variants[index].commission = 0;
        this.variants[index].commissionPercentage = 0;
        this.variants[index].discount = 0;
      }
    },

    UploadData() {
      if (this.$refs.form.validate()) {
        for (let i = 0; i < this.variants.length; i++) {
          this.variants[i].index = i;
        }

        this.appLoading = true;
        axios({
          url: "/grocery/add/products",
          method: "post",
          headers: {
            token: localStorage.getItem("token"),
          },
          data: {
            hsnId: this.HSNCode,
            sellerId: this.$route.query.sellerId,
            categoryId: this.category,
            subcategoryId: this.Subcategory,
            type: this.foodType,
            name: this.name,
            description: this.description,
            productDetails: this.productDetail,
            brandId: this.brand,
            varient: this.variants,
          },
        })
          .then((response) => {
            if (response.data.status) {
              (this.showSnackBar = true),
                (this.msg = response.data.msg),
                (this.PRIDS = response.data.varient);
              this.stockId = response.data.varient[0]._id;

              for (let i = 0; i < this.PRIDS.length; i++) {
                let A = new FormData();
                A.append("id", this.PRIDS[i]._id);
                A.append("photo", this.productImages[i]);
                A.append("productPhoto", this.packingImages[i]);
                A.append("packedPhoto", this.packedImages[i]);
                axios({
                  url: "/grocery/upload/product/image",
                  method: "POST",
                  headers: {
                    token: localStorage.getItem("token"),
                  },
                  data: A,
                })
                  .then((response) => {
                    (this.showSnackBar = true), (this.msg = response.data.msg);
                  })
                  .catch((err) => {
                    this.appLoading = false;
                    this.ServerError = true;
                    console.log(err);
                  });
              }
              this.appLoading = false;

              if (this.appLoading == false) {
                setTimeout(
                  () =>
                    this.$router.push("/groceryProductInfo?id=" + this.stockId),
                  2000
                );
              }
            } else {
              this.appLoading = false;
              this.showSnackBar = true;
              this.msg = response.data.msg;
            }
          })
          .catch((err) => {
            this.appLoading = false;
            this.ServerError = true;
            console.log(err);
          });
      }
    },

    winStepper(window_data) {
      if (window_data.type == "offerImage") {
        // this.itemImage = window_data.selectedFiles;
        this.productImages[window_data.index] = window_data.selectedFiles;
      }
      if (window_data.type == "packingImage") {
        this.packingImages[window_data.index] = window_data.selectedFiles;
      }
      if (window_data.type == "restaurantImage") {
        this.packedImages[window_data.index] = window_data.selectedFiles;
      }
    },

    checkDiscountvariant(index) {
      if (
        this.variants[index].discount >= 0 &&
        this.variants[index].discount < 100
      ) {
        this.variants[index].offerPrice = (
          this.variants[index].price -
          (this.variants[index].price * this.variants[index].discount) / 100
        ).toFixed(2);
      } else {
        this.msg = "Please Provide valid discount";
        this.snackbar = true;
        this.variants[index].offerPrice = 0;
        this.variants[index].discount = 0;
      }
      if (
        this.variants[index].commissionPercentage >= 0 &&
        this.variants[index].commissionPercentage < 100
      ) {
        this.variants[index].commission =
          (this.variants[index].offerPrice *
            this.variants[index].commissionPercentage) /
          100;
      } else {
        this.msg = "Please Provide valid commission percentage";
        this.snackbar = true;
      }
    },

    addVariant() {
      this.variants.push({ ...this.singleVariant });
    },

    getCategory() {
      this.appLoading = true;
      axios({
        url: "/grocery/category/list/62b16b36fdd907192c69f476",
        method: "get",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          this.CategoryList = response.data.data;
          this.pages = response.data.totalPages;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getSubCategory(item) {
      this.appLoading = true;
      axios({
        url: "/grocery/subcategory/list/" + item,
        method: "get",
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;

          this.SubCategoryList = response.data.data;
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    getWeek() {
      if (this.isEntireWeek) this.availableDays = this.weekdays;
      if (this.isEntireWeek == false) this.availableDays = [];
    },
    formatTime(item) {
      if (!item) return;
      var hours = Number(item.split(":")[0]);
      var minutes = Number(item.split(":")[1]);
      var ampm = hours >= 12 ? "PM" : "AM";
      hours = hours % 12;
      hours = hours ? hours : 12;
      minutes = minutes < 10 ? "0" + minutes : minutes;
      var strTime = hours + ":" + minutes + " " + ampm;
      return strTime;
    },
    openDialog(start, end, item, index) {
      this.estart = start;
      this.availableDays = item.availableDays;
      this.eend = end;
      this.editingItem = item;
      this.editingItem.index = index;
      this.estart = this.editingItem.start;
      this.eend = this.editingItem.end;
      this.EditTimingDialog = true;
    },
    addTiming() {
      this.CommonFields.availableTimings.push({
        start: this.startTime,
        end: this.endTime,
        availableDays: this.availableDays,
      });
      this.startTime = null;
      this.endTime = null;
      this.availableDays = [];
      this.addTimingDialog = false;
      this.isEntireWeek = false;
    },

    getProductTypes() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/seller/type/list/",
        params: {
          userid: this.$route.query.seller,
        },
      }).then((response) => {
        if (response.data.status) {
          this.productTypes = response.data.data;
          this.appLoading = false;
        } else {
          this.appLoading = false;
        }
      });
    },
    getCategories() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/seller/category/list/",
        params: {
          userid: this.$route.query.seller,
        },
      }).then((response) => {
        if (response.data.status) {
          this.categories = response.data.data;
          this.appLoading = false;
        } else {
          this.appLoading = false;
        }
      });
    },
    getAllergens() {
      this.appLoading = true;
      axios({
        method: "get",
        url: "/allergens/list",
      }).then((response) => {
        if (response.data.status) {
          this.allergensList = response.data.data;
          this.appLoading = false;
        } else {
          this.appLoading = false;
        }
      });
    },
  },
};
</script>